import React from 'react';
import { connect } from 'react-redux';

import { screen } from '$fcomponents/hoc';
import { BALANCE_REPORT_TABLE, BALANCE_REPORT_TABLE_CONFIG } from './balanceReportTable';
import ReportComponent from '../reportComponent';
// import PATH from '$business/enums/paths';
interface BalanceReportScreenProps {
  factory;
  history;
  dateFilter;
}

const BalanceReportScreen: React.FC<BalanceReportScreenProps> = ({ history, dateFilter }) => {
  const handleRowClick = (storeId) => {
    // history.push(PATH.REPORT_ITEM_DETAILS + '/0/' + storeId + '/0');
  };

  const onTableLoad = (total, newTotal, response) => {
    console.log('ON TABLE LOAD BALANCE', total, newTotal, response);
    // Display Summary info
  };

  return (
    <ReportComponent
      title="SCREEN.REPORT.TITLE_STORE_BALANCE"
      table={BALANCE_REPORT_TABLE(handleRowClick)}
      tableConfig={BALANCE_REPORT_TABLE_CONFIG}
      onTableLoad={onTableLoad}
      dateFilter={dateFilter}
    />
  );
};

const mapStateToProps = (state) => ({
  factory: state.factory,
});

const mapDispatchToProps = {};

const connected = connect(mapStateToProps, mapDispatchToProps);

export default connected(screen(BalanceReportScreen));
